import { render, staticRenderFns } from "./replaced_subscriptions.vue?vue&type=template&id=a5889fa0&scoped=true"
import script from "./replaced_subscriptions.vue?vue&type=script&lang=js"
export * from "./replaced_subscriptions.vue?vue&type=script&lang=js"
import style0 from "./replaced_subscriptions.vue?vue&type=style&index=0&id=a5889fa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5889fa0",
  null
  
)

export default component.exports